import { WorkingHourInterval } from "@/domain/entities/WorkingHourInterval"
import { EWeekday } from "@/domain/enums/EWeekday"
import { WorkingHours as WorkingHourResponseDataDTO } from "../dto/ProfessionalDetailResponseDTO"

// A API devolve start_time/end_time como "HH:mm:ss" — domínio trabalha só
// com "HH:mm" (mesmo corte feito no app do profissional).
const toEntity = (data: WorkingHourResponseDataDTO): WorkingHourInterval => ({
    weekday: data.weekday as EWeekday,
    start_time: data.start_time?.slice(0, 5),
    end_time: data.end_time?.slice(0, 5),
})

const toEntityList = (data: WorkingHourResponseDataDTO[]): WorkingHourInterval[] =>
    (data || []).map(toEntity)

export default { toEntity, toEntityList }
